module.exports = __webpack_public_path__ + "img/7.9608b3db.jpg";